/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import React, { Fragment, useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { SnackbarProvider } from 'notistack';
import CssBaseline from '@material-ui/core/CssBaseline';
import Cookies from 'js-cookie';
// import LogRocket from 'logrocket'; // logrocket
import { LanguageContext } from '../../languagecontext';
import localeData from '../../translations/language.json';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import Notifier from '../Layout/snackbar/Notifier';
import { Loading } from '../../helpers/utils';

import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';

// LogRocket.init('ojxswb/mw-client-access'); // logrocket

let defLanguage;

if (Cookies.get('language')) {
  defLanguage = Cookies.get('language');
} else {
  defLanguage = (navigator.languages && navigator.languages[0])
  || navigator.language
  || navigator.userLanguage;
}
const defLanguageWithoutRegionCode = defLanguage.toLowerCase().split(/[_-]+/)[0];
const defMessages = localeData[defLanguageWithoutRegionCode]
|| localeData[defLanguage]
|| localeData.en;

const App = () => {
  const toggleLanguage = (language) => {
    const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
    const messages = localeData[languageWithoutRegionCode]
    || localeData[defLanguage]
    || localeData.en;
    // eslint-disable-next-line no-use-before-define
    setLocales({ language, messages, toggleLanguage });
  };

  const [loaded, setLoaded] = useState(false);
  const [locales, setLocales] = useState(
    {
      language: defLanguage,
      messages: defMessages,
      toggleLanguage,
    },
  );

  useEffect(() => {
    window.addEventListener('load', () => {
      setLoaded(true);
    });
  }, []);

  return (
    <LanguageContext.Provider value={locales}>
      <IntlProvider locale={locales.language} messages={locales.messages}>
        <Provider store={store}>
          <CssBaseline />
          <SnackbarProvider maxSnack={5}>
            <Notifier />
            <BrowserRouter>
              <ScrollToTop>
                <>
                  {!loaded && (<Loading />) }
                  <div>
                    <Router />
                  </div>
                </>
              </ScrollToTop>
            </BrowserRouter>
          </SnackbarProvider>
        </Provider>
      </IntlProvider>
    </LanguageContext.Provider>
  );
};

export default hot(module)(App);
